import { VisuallyHidden } from "react-aria-components";
import "./TokenWrittenAs.css";

// The text a sent message holds for a token ("/summarize", "@Jane Doe"), hidden: the token around it can't be selected, so
// a copy of the message writes this in its place and pastes back as it was typed. Screen readers read the token instead.
export const TokenWrittenAs = ({ text }: { text: string }) => (
    <VisuallyHidden className="wai-token-written-as" aria-hidden data-testid="token-written-as">{text}</VisuallyHidden>
);
